'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// UI lib components
import { Group, Text } from '@mantine/core';

// UI local components
import User from '@ui-kit/atoms/User';

// Types
import { UserNoteProps } from './types';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function UserNote({ user, note = '' }: UserNoteProps) {
  return (
    <Group justify="center" gap="xs">
      <Text>{`${note ? `${note} ` : ''}${user.firstName}`}</Text>
      <User user={user} size="md" />
    </Group>
  );
}

export default UserNote;
